import PhotoAnnounce from "./PhotoAnnounce.vue";

export default PhotoAnnounce;
